


























































































import { cloneDeep, snakeCase } from 'lodash';
import Vue from "vue";
import { Component, Prop, VModel } from 'vue-property-decorator'

import { SelectOptionData } from '../../../../../components/Pi/types'
import TypeSelect from '../../../../../components/TypeSelect.vue'
import { IterableItemFactory } from "../../../../utils/IterableItemFactory";
import { getConditionBuilders } from "../conditions";
import { EXTRA_CONDITIONS } from "../constants";
import { AutoReplyConditions, AutoReplyConditionTypeEnum, LocalAutoReplyAction } from '../types'
import ActionCardConditionsGroup from './ActionCardConditionsGroup.vue'

@Component({
  components: {
    TypeSelect,
    ActionCardConditionsGroup,
  },
  data() {
    return {
      AutoReplyConditionTypeEnum,
    }
  }
})
export default class ActionCardConditions extends Vue {
  @VModel() conditions!: LocalAutoReplyAction['conditions']

  @Prop({ type: Boolean, default: false }) commandsConditions!: boolean

  itemFactory = new IterableItemFactory()

  conditionsToEdit: LocalAutoReplyAction['conditions'] | null = null

  isExtraConditionsModalOpen = false

  conditionBuilders = getConditionBuilders()

  get conditionOptions(): Array<SelectOptionData> {
    return Object.values(AutoReplyConditionTypeEnum)
      .map((type) => {
        return {
          label: this.$t(`auto_reply_${ snakeCase(type) }_option`).toString(),
          value: type
        }
      })
  }

  get extraConditionOptions(): Array<SelectOptionData> {
    return [
      ...this.conditionOptions,
      {
        label: this.$t('extra_trigger_setting_option').toString(),
        value: EXTRA_CONDITIONS
      }
    ]
  }

  prepareExtraConditions() {
    this.conditionsToEdit = cloneDeep(this.conditions)

    this.isExtraConditionsModalOpen = true
  }

  saveCondition() {
    if (this.conditionsToEdit) {
      this.conditions = cloneDeep(this.conditionsToEdit)

      this.conditionsToEdit = null;
    }

    this.isExtraConditionsModalOpen = false
  }

  changeConditionType(type: AutoReplyConditionTypeEnum | typeof EXTRA_CONDITIONS): void {
    if (type === EXTRA_CONDITIONS) {
      this.prepareExtraConditions()
    } else {
      this.conditions[0].value[0].value = this.conditionBuilders?.[type]?.getModel() ?? { type }
    }
  }

  addGroup(): void {
    if (this.conditionsToEdit) {
      this.conditionsToEdit.push(this.itemFactory.create([]))
    }
  }

  removeGroup(parentGuid: string): void {
    if (this.conditionsToEdit) {
      this.conditionsToEdit = this.conditionsToEdit.filter(g => g.guid !== parentGuid)
    }
  }

  addCondition({ parentGuid, condition }: { parentGuid: string, condition: AutoReplyConditions }): void {
    if (this.conditionsToEdit) {
      const parent = this.conditionsToEdit.find((g) => g.guid === parentGuid)

      if (parent) {
        parent.value.push(this.itemFactory.create(condition))
      }
    }
  }

  removeCondition({ parentGuid, conditionGuid }: { parentGuid: string, conditionGuid: string }): void {
    if (this.conditionsToEdit) {
      const group = this.conditionsToEdit.find((g) => g.guid === parentGuid)

      if (group) {
        group.value = group.value.filter(c => c.guid !== conditionGuid)
      }
    }
  }
}
